import LabelWithImput from './component'

export default LabelWithImput
